import React from "react";

const LoadingOverlay = ({ loading, loader }) => {
  if (!loading) return null;

  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <img src={loader} alt="Loading..." style={{ width: "60px", height: "60px" }} />
    </div>
  );
};

export default LoadingOverlay;
